import Buttons from './buttons.vue';
import ButtonsMenu from './buttons-menu.vue';
import ButtonsItem from './buttons-item.vue';

Buttons.Menu = ButtonsMenu;
Buttons.Item = ButtonsItem;
export default Buttons;
